import { __assign, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import * as React from 'react';
import classnames from 'classnames';
import { LabelElement } from './Label.styles';
var Label = React.forwardRef(function (_a, ref) {
  var dense = _a.dense,
      hasValue = _a.hasValue,
      active = _a.active,
      error = _a.error,
      disabled = _a.disabled,
      labelProps = __rest(_a, ["dense", "hasValue", "active", "error", "disabled"]);

  var className = labelProps.className;
  var rootClassName = classnames(className, {
    dense: dense,
    hasValue: hasValue,
    active: active,
    error: error,
    disabled: disabled
  });
  return _jsx(LabelElement, __assign({}, labelProps, {
    className: rootClassName,
    ref: ref
  }));
});
export default memo(Label);